import React, { useEffect } from 'react'
import './WhiteMenuSection.css'
import Arrow2 from '../images/svg/Arrow2.svg'
import BlueButtonWhiteBg from './BlueButtonWhiteBg'
import DecoIco1 from '../images/svg/decoIco1.svg'
import DecoIco2 from '../images/svg/decoIco2.svg'
import DecoIco3 from '../images/svg/decoIco3.svg'



function WhiteMenuSection() {
    useEffect(() => {
        const handleClick = (event) => {
            const titleContainer = event.currentTarget;
            const arrow = titleContainer.querySelector('.arrow-right');
            const descriptionParent = titleContainer.querySelector('.description-parent');
            const descriptionChild = titleContainer.querySelector('.description-child')

            if (arrow.classList.contains('arrow-right-active')) {
                arrow.classList.remove('arrow-right-active');
            } else {
                arrow.classList.add('arrow-right-active');
            }

            if (descriptionParent.classList.contains('description-parent-active')) {
                descriptionParent.classList.remove('description-parent-active');
                descriptionParent.style.height = 0;
            } else {
                descriptionParent.classList.add('description-parent-active');
                descriptionParent.style.height = descriptionChild.offsetHeight + 50 + 'px';
            }
        };

        const titleContainers = document.querySelectorAll('.title');

        titleContainers.forEach((titleContainer) => {
            titleContainer.addEventListener('click', handleClick);
        });

        return () => {
            titleContainers.forEach((titleContainer) => {
                titleContainer.removeEventListener('click', handleClick);
            });
        };

    }, []);

    return (
        <div className='white-menu-section'>
            <div className='white-menu-grid'>
                <div className='white-menu-left' id='contact-form'>
                    <h3>
                        We don’t run campaigns.<br />
                        We build growth<br /> architecture.
                    </h3>
                    <p className='description' >
                            Traditional marketing focuses on channels.
                            We focus on systems.<br />
                            We design AI-powered frameworks that automate acquisition, optimize performance, and turn operations into scalable engines.
                    </p>

                    <div className='contact-form-div' >
                        <p className='contact-description'>
                            
                            <strong>If you're ready</strong> to replace manual effort with intelligent infrastructure — <strong>you're in the right place.</strong>
                        </p>
                        <div className='icons-and-button'>

                            <div className='deco-icons'>

                                <img src={DecoIco1} alt='decoration icon' className='deco-icon deco-icon-1' />
                                <img src={DecoIco2} alt='decoration icon' className='deco-icon deco-icon-2' />
                                <img src={DecoIco3} alt='decoration icon' className='deco-icon deco-icon-3' />
                            </div>
                            <div className='button-send'>
                                <BlueButtonWhiteBg text='Send message' className='send-message' />
                            </div>

                        </div>
                    </div>

                </div>
                <div className='white-menu-right'>
                    <div className='white-menu-right-grid'>
                        <div className='number'><span>01</span></div>
                        <div className='title'><h4>Growth Architecture</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>Growth Architecture is the foundation of a scalable business. Instead of operating in disconnected channels, we design a complete growth structure — from acquisition to conversion, retention, and continuous optimization. Every component has a defined role within a unified system.
                                        <br />
                                        <br />
                                        This approach eliminates marketing chaos and replaces it with predictable performance. Strategy, automation, and data operate together — creating a repeatable engine for sustainable scale.
                                    </p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>02</span></div>
                        <div className='title'><h4>AI Automation</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>AI Automation replaces repetitive manual processes with intelligent workflows. From content generation to lead qualification and performance optimization, the system executes faster and with greater precision than traditional operations.
                                        <br />
                                        <br />
                                        Automation doesn’t replace your team — it amplifies it. With AI, you can scale output without proportionally increasing operational costs.</p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>03</span></div>
                        <div className='title'><h4>Conversion Systems</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>Conversion should never rely on chance. We design structured systems that guide users through a logical decision journey — from first interaction to final action.
                                        <br />
                                        <br />
                                        By analyzing behavioral signals and optimizing every touchpoint, we increase efficiency across the funnel. This isn’t a one-time campaign — it’s a continuously improving revenue mechanism.</p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>04</span></div>
                        <div className='title'><h4>Data Intelligence</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>Data Intelligence transforms information into strategic leverage. We collect, integrate, and analyze signals across platforms to drive decisions based on measurable insights.
                                        <br />
                                        <br />
                                        The result is clarity and precision. No assumptions — only structured decision-making powered by real-time intelligence.</p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>05</span></div>
                        <div className='title'><h4>Performance Optimization</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>Performance Optimization is an ongoing process of testing, measuring, and refining. We monitor key metrics, identify bottlenecks, and eliminate inefficiencies in real time.
                                        <br />
                                        <br />
                                       Every iteration strengthens performance. Budgets work harder, systems improve continuously, and growth becomes more stable and scalable.</p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>06</span></div>
                        <div className='title'><h4>Workflow Integration</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>Modern businesses operate across multiple tools — CRM systems, advertising platforms, content engines, and analytics environments. We connect them into a synchronized infrastructure.
                                        <br />
                                        <br />
                                        Data flows seamlessly across systems, reducing friction and eliminating manual redundancies. The result is operational clarity and accelerated execution.</p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>07</span></div>
                        <div className='title'><h4>Custom AI Development</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>
                                    <p>Not every business fits into pre-built frameworks. We design tailored AI solutions aligned with your business model, operational structure, and long-term strategy.
                                        <br />
                                        <br />
                                        From proprietary automation logic to custom AI architectures, we build systems that evolve with your organization and create durable competitive advantage.</p>
                                    <BlueButtonWhiteBg text='Free quote' />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default WhiteMenuSection